module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "admin"
  }, [(_vm.authorized === true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1 col-xs-12"
  }, [_c('md-whiteframe', {
    staticClass: "navigation"
  }, [_c('md-list', [_c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/admin/home"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('md-icon', [_vm._v("dashboard")]), _c('br'), _vm._v(_vm._s(_vm.$t("home_page")))], 1)])], 1), _vm._v(" "), _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/admin/patients"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('md-icon', [_vm._v("accessibility")]), _c('br'), _vm._v(_vm._s(_vm.$t("patients")))], 1)])], 1), _vm._v(" "), (_vm.admin) ? _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/admin/doctors"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('md-icon', [_vm._v("local_hospital")]), _c('br'), _vm._v(_vm._s(_vm.$t("admin.doctors")))], 1)])], 1) : _vm._e(), _vm._v(" "), _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/admin/profile"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('md-icon', [_vm._v("person")]), _c('br'), _vm._v(" " + _vm._s(_vm.$t("profile")))], 1)])], 1), _vm._v(" "), _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": "/admin/feed"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('md-icon', [_vm._v("public")]), _c('br'), _vm._v(_vm._s(_vm.$t("news")))], 1)])], 1), _vm._v(" "), _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        _vm.openDialog()
      }
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('md-icon', [_vm._v("warning")]), _c('br'), _vm._v(_vm._s(_vm.$t("report_problem")))], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md col-xs-12"
  }, [_c('router-view')], 1)]) : _c('div', [_vm._v("\n\t\t\t" + _vm._s(_vm.$t("admin.needsignin")) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "admin-footer"
  }, [_vm._v("\n\t\t\tPulmoment.com - Build: " + _vm._s(_vm.getHash()) + "\n\t\t")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f6faf1f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/AdminView.vue
// module id = 422
// module chunks = 2